import { Quote, ShieldCheck, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { REVIEWS, COMPANY } from "@/data/siteData";

export const Testimonials = () => (
  <section data-testid="home-testimonials" className="bg-primary py-24 text-white lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionHeading light eyebrow="Verified BBB Reviews" title="Trusted by homeowners across Ohio." />
            <a
              href={COMPANY.bbbUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="testimonials-bbb-link"
              className="mt-10 inline-flex items-center gap-3 rounded-2xl border border-white/15 bg-white/5 p-5 transition-colors hover:bg-white/10"
            >
              <ShieldCheck className="h-9 w-9 text-accent" strokeWidth={1.25} />
              <span className="text-sm">
                <span className="block font-medium">BBB Accredited Business</span>
                <span className="block text-white/60">A Rating &middot; Accredited since 6/2025</span>
              </span>
              <ArrowUpRight className="ml-2 h-4 w-4 text-white/60" />
            </a>
          </Reveal>
        </div>
        <div className="grid gap-6 lg:col-span-8 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1} className="flex flex-col rounded-2xl border border-white/10 bg-white/5 p-7">
              <Quote className="h-6 w-6 text-accent" strokeWidth={1.25} />
              <p data-testid={`review-text-${i}`} className="mt-5 flex-1 text-sm font-light leading-relaxed text-white/85">{r.text}</p>
              <p className="mt-6 text-xs uppercase tracking-[0.2em] text-accent">{r.name}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
